import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstanceV2 from '../../Apis/AxiosV2';
import axios from "axios";
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";
import apiInstance from "../../Apis/Axios";
import { REQUEST_ACCESS_SERVICE } from '../EndPoints';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const CreateRequestAccess = createAsyncThunk('request/CreateRequestAccess', async (params, { dispatch, getState }) => {
    const response = await apiInstanceV2
        .post(REQUEST_ACCESS_SERVICE.createRequestAccess, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const GetRequestAccessById = createAsyncThunk(
    'requestAccess/getRequestAccessById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${REQUEST_ACCESS_SERVICE.getRequestAccessById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetRequestAccessAssets = createAsyncThunk(
    'requestAccess/getRequestsAccessAssets',
    async (param, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${REQUEST_ACCESS_SERVICE.getRequestAccessAssets}${param}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ApplyDecisionRequest = createAsyncThunk(
    'requestAccess/applyDecisionRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(REQUEST_ACCESS_SERVICE.applyDecisionRequest, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const AssignEmployeeRequest = createAsyncThunk(
    'requestAccess/assignEmployeeRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(REQUEST_ACCESS_SERVICE.assignEmployeeRequest, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);



export const PublicCreateRequest = createAsyncThunk('request/publicCreateRequest', async (params, { dispatch, getState }) => {
    try {
        return await axios.post(`${URL}${REQUEST_ACCESS_SERVICE.publicCreateRequest}`, params);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const PublicCreateRequestDocument = createAsyncThunk('request/CreateRequestDocument', async (params, { dispatch, getState }) => {
    try {
        return await axios.post(`${URL}${REQUEST_ACCESS_SERVICE.createRequestDocument}`, params, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const RequestAccessMarkFilesAsRead = createAsyncThunk('request/markFilesAsRead', async (body) => {
    const response = await apiInstance
        .post(REQUEST_ACCESS_SERVICE.markFilesAsRead, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
